/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostAuthTokenRequestBodyTypename = "PostAuthTokenRequestBody" as const;

/**
 *
 * @export
 * @interface PostAuthTokenRequestBody
 */
export interface PostAuthTokenRequestBody {
  /**
   *
   * @type {number}
   * @memberof PostAuthTokenRequestBody
   */
  chainId: number;
  /**
   *
   * @type {number}
   * @memberof PostAuthTokenRequestBody
   */
  pharmacyId: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostAuthTokenRequestBody
   */
  readonly __typename?: string;
}

export function PostAuthTokenRequestBodyFromJSON(json: any): PostAuthTokenRequestBody {
  return PostAuthTokenRequestBodyFromJSONTyped(json, false);
}

export function PostAuthTokenRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostAuthTokenRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostAuthTokenRequestBodyTypename,

    chainId: json["chain_id"],
    pharmacyId: json["pharmacy_id"],
  };
}

export function PostAuthTokenRequestBodyToJSON(object?: PostAuthTokenRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    chain_id: value.chainId,
    pharmacy_id: value.pharmacyId,
  };
}
